import store from '@/store'

export default [
  {
    path: '/expense-records',
    name: 'expense-record',
    meta: { requireAuth: true },
    component: () => import('@/pages/expense-record/index.vue')
  },
  {
    path: '/expense-records/create',
    name: 'expense-record-create',
    meta: { requireAuth: true },
    component: () => import('@/pages/expense-record/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('expenseRecord/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/expense-records/:id',
    name: 'expense-record-edit',
    meta: { requireAuth: true },
    component: () => import('@/pages/expense-record/edit.vue'),
    props: route => ({ expenseRecord: route.params.expenseRecord }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('expenseRecord/dataBeforeCreate')
      let response = await store.dispatch('expenseRecord/find', to.params.id)
      let { expense_item, currency, ...resource } = response.data
      to.params.expenseRecord = resource
      next()
    }
  }
]
